import { useTranslation } from 'next-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Body, FileUpload, FlexBox, FormControl, FormError, Headline, Input, Message } from '@Backlot-Cars/archie';
import { Container, RowOnDesktopColumnOnMobile } from './styles';
import { getFileName, parseUrl } from './helpers';
import SignUpFormActions from './FormActions';
import SignUpHeader from './header';
import SignupResumeMessage from './ResumeMessage';

const StepTwo = (props) => {
	const { t } = useTranslation(['common', 'signup']);
	const { onSubmit, initialValues } = props;
	const {
		register,
		handleSubmit,
		formState: { errors, isSubmitting },
		setValue,
		watch,
	} = useForm({
		defaultValues: {
			...initialValues,
		},
		resolver: yupResolver(props.validationSchema),
	});

	const dealerLicenseFile = watch('dealerLicenseFile');
	const driverLicenseFile = watch('driverLicenseFile');
	const dealerLicenseUrl = watch('dealerLicenseUrl');
	const driverLicenseUrl = watch('driverLicenseUrl');

	const unsetValue = (field) => {
		setValue(field, null);
	};

	return (
		<>
			<SignupResumeMessage resumeStep={props.resumeStep} backButtonClicked={props.backButtonClicked} />
			<SignUpHeader title={t('signup:steps.step3.title')} />
			<Message color="success" borderColor="success" iconName="unlock" iconColor="success">
				<FlexBox flexDirection="column" gap="8px">
					<FlexBox>
						<Headline size="H6">You're almost ready to preview inventory!</Headline>
					</FlexBox>
					<FlexBox>
						<Body>{t('signup:steps.step3.subTitle')}</Body>
					</FlexBox>
				</FlexBox>
			</Message>
			<RowOnDesktopColumnOnMobile>
				<FormControl
					label={t('signup:steps.step3.dealerLicenseFile')}
					tooltipMessage={t('signup:steps.step3.dealerLicenseFileInformation')}
					tooltipPosition="bottom"
					formErrors={errors}
				>
					<FileUpload
						accept={['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
						lastFileName={getFileName(dealerLicenseFile)}
						lastFileUrl={dealerLicenseUrl || parseUrl(dealerLicenseFile)}
						handleRemove={() => unsetValue('dealerLicenseFile')}
						fullWidth
						{...register('dealerLicenseFile')}
					/>
				</FormControl>
			</RowOnDesktopColumnOnMobile>
			<Container>
				<FormControl
					label={t('signup:steps.step3.taxID')}
					tooltipMessage={t('signup:steps.step3.taxIDInformation')}
					formErrors={errors}
				>
					<Input
						id="taxID"
						placeholder={t('signup:steps.step3.taxIDPlaceholder')}
						maxLength="255"
						{...register('taxID')}
					/>
				</FormControl>
			</Container>
			<Container>
				<FormControl
					label={t('signup:steps.step3.driverLicenseFile')}
					tooltipMessage={t('signup:steps.step3.driverLicenseFileInformation')}
					tooltipPosition="bottom"
					formErrors={errors}
				>
					<FileUpload
						accept={['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}
						lastFileName={getFileName(driverLicenseFile)}
						lastFileUrl={driverLicenseUrl || parseUrl(driverLicenseFile)}
						handleRemove={() => unsetValue('driverLicenseFile')}
						fullWidth
						{...register('driverLicenseFile')}
					/>
				</FormControl>
			</Container>
			<FormError text={props.error} />
			<SignUpFormActions
				handleSubmit={handleSubmit((values) => onSubmit(values))}
				isSubmitting={isSubmitting}
				backCopy={t('signup:actions.back')}
				nextCopy={t('signup:actions.next')}
				{...props}
			/>
		</>
	);
};

export default StepTwo;
